/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apply_OffsetInputs */

const en_apply_offset = /** @type {(inputs: Apply_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply Offset`)
};

const fr_apply_offset = /** @type {(inputs: Apply_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appliquer le décalage`)
};

const de_apply_offset = /** @type {(inputs: Apply_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offset anwenden`)
};

const it_apply_offset = /** @type {(inputs: Apply_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applica offset`)
};

const ru_apply_offset = /** @type {(inputs: Apply_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Применить смещение`)
};

const es_apply_offset = /** @type {(inputs: Apply_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar desplazamiento`)
};

const zh_cn2_apply_offset = /** @type {(inputs: Apply_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`应用偏移`)
};

const ja_apply_offset = /** @type {(inputs: Apply_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オフセットを適用`)
};

const hi_apply_offset = /** @type {(inputs: Apply_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑफसेट लागू करें`)
};

const pt_pt2_apply_offset = /** @type {(inputs: Apply_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar deslocamento`)
};

/**
* | output |
* | --- |
* | "Apply Offset" |
*
* @param {Apply_OffsetInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const apply_offset = /** @type {((inputs?: Apply_OffsetInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apply_OffsetInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_apply_offset(inputs)
	if (locale === "de") return de_apply_offset(inputs)
	if (locale === "it") return it_apply_offset(inputs)
	if (locale === "ru") return ru_apply_offset(inputs)
	if (locale === "es") return es_apply_offset(inputs)
	if (locale === "zh-CN") return zh_cn2_apply_offset(inputs)
	if (locale === "ja") return ja_apply_offset(inputs)
	if (locale === "hi") return hi_apply_offset(inputs)
	if (locale === "pt-PT") return pt_pt2_apply_offset(inputs)
	return en_apply_offset(inputs)
});